/**
 * Web component: review-list (review-list)
 * -----------------------------------------------------------------------------
 * displays the widget for product reviews on detail page.
 * - Component settings: section / static / web
 *
 */
import { vueReady } from '~/core/runners';

import './review-list.scss';

class ReviewList extends HTMLElement {
  data() {
    return {
      legalText: this.getAttribute('data-legal-text'),
      legalLink: this.getAttribute('data-legal-link'),
    };
  }

  /**
   * Custom element constructor.
   * - Always call super first in constructor.
   */
  constructor() {
    super();
    this.$data = this.data(this);
  }

  connectedCallback() {
    if (!document.querySelector('.kl_reviews__summary__link')) {
      this.waitForElement('.kl_reviews__summary__stars__count', {
        timeout: 10000,
        interval: 200,
      }).then((el) => {
        const linkText = this.createLinkElement();

        el.appendChild(linkText);
      });
    }
  }

  createLinkElement() {
    const linkReviews = document.createElement('a');
    linkReviews.href = this.$data.legalLink;
    linkReviews.target = '_blank';
    linkReviews.className = 'kl_reviews__summary__link';
    linkReviews.textContent = this.$data.legalText;
    linkReviews.style.display = 'block';
    linkReviews.style.fontSize = '0.8rem';

    return linkReviews;
  }

  waitForElement(selector, { timeout = 20000, interval = 100 } = {}) {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      const handle = setInterval(() => {
        const el = document.querySelector(selector);
        if (el) {
          clearInterval(handle);
          resolve(el);
        } else if (Date.now() - start >= timeout) {
          clearInterval(handle);
          reject(new Error(`Timed out waiting for selector: ${selector}`));
        }
      }, interval);
    });
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('review-list')) {
    return;
  }

  customElements.define('review-list', ReviewList);
});
